import {
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED,
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED,
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS,
  CLONE_EVENT_CALENDAR,
  CLONE_EVENT_CALENDAR_FAILED,
  CLONE_EVENT_CALENDAR_SUCCESS,
  CREATE_EVENT_CALENDAR,
  CREATE_EVENT_CALENDAR_FAILED,
  CREATE_EVENT_CALENDAR_SUCCESS,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_FAILED,
  DELETE_CALENDAR_EVENT_SUCCESS,
  DELETE_EVENT_CALENDAR,
  DELETE_EVENT_CALENDAR_FAILED,
  DELETE_EVENT_CALENDAR_SUCCESS,
  GET_ALL_CALENDAR_EVENTS,
  GET_ALL_CALENDAR_EVENTS_FAILED,
  GET_ALL_CALENDAR_EVENTS_SUCCESS,
  GET_ALL_EVENTS_CALENDAR,
  GET_ALL_EVENTS_CALENDAR_FAILED,
  GET_ALL_EVENTS_CALENDAR_SUCCESS,
  GET_CALENDAR_EVENT,
  GET_CALENDAR_EVENT_FAILED,
  GET_CALENDAR_EVENT_SUCCESS,
  GET_EVENTS_CALENDAR,
  GET_EVENTS_CALENDAR_FAILED,
  GET_EVENTS_CALENDAR_SUCCESS,
  GET_EVENT_CALENDAR_GROUP,
  GET_EVENT_CALENDAR_GROUP_FAILED,
  GET_EVENT_CALENDAR_GROUP_SUCCESS,
  HIDE_CLONE_EVENT_CALENDAR_MODAL,
  HIDE_DELETE_CALENDAR_EVENT_MODAL,
  HIDE_DELETE_EVENT_CALENDAR_MODAL,
  OPEN_CLONE_EVENT_CALENDAR_MODAL,
  OPEN_DELETE_CALENDAR_EVENT_MODAL,
  OPEN_DELETE_EVENT_CALENDAR_MODAL,
  RESET_EVENT_CALENDAR_GROUP,
  UPDATE_EVENT_CALENDAR,
  UPDATE_EVENT_CALENDAR_FAILED,
  UPDATE_EVENT_CALENDAR_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  calendars: [],
  calendarEvents: [],
  eventsAreLoading: false,
  allEventsCalendar: [],
  allCalendarEvents: [],
  selectedCalendar: null,
  deleteEventCalendarModalIsOpen: false,
  eventCalendarCanBeDeleted: false,
  cloneEventCalendarModalIsOpen: false,
  deleteCalendarEventModalIsOpen: false,
}

const Events = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS_CALENDAR:
    case GET_ALL_EVENTS_CALENDAR:
    case GET_ALL_CALENDAR_EVENTS:
    case GET_EVENT_CALENDAR_GROUP:
    case CREATE_EVENT_CALENDAR:
    case UPDATE_EVENT_CALENDAR:
    case CHECK_EVENT_CALENDAR_CAN_BE_DELETED:
    case DELETE_EVENT_CALENDAR:
    case CLONE_EVENT_CALENDAR:
    case DELETE_CALENDAR_EVENT:
      return {
        ...state,
        loading: true,
      }
    case GET_CALENDAR_EVENT:
      return {
        ...state,
        eventsAreLoading: true,
      }
    case GET_EVENTS_CALENDAR_FAILED:
    case GET_ALL_EVENTS_CALENDAR_FAILED:
    case GET_ALL_CALENDAR_EVENTS_FAILED:
    case GET_EVENT_CALENDAR_GROUP_FAILED:
    case CREATE_EVENT_CALENDAR_FAILED:
    case UPDATE_EVENT_CALENDAR_FAILED:
    case DELETE_EVENT_CALENDAR_FAILED:
    case CHECK_EVENT_CALENDAR_CAN_BE_DELETED_FAILED:
    case CLONE_EVENT_CALENDAR_FAILED:
    case DELETE_CALENDAR_EVENT_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_CALENDAR_EVENT_FAILED:
      return {
        ...state,
        error: action.payload,
        eventsAreLoading: false,
      }
    case GET_EVENTS_CALENDAR_SUCCESS:
      return {
        ...state,
        calendars: action.payload,
        loading: false,
      }
    case GET_CALENDAR_EVENT_SUCCESS:
      return {
        ...state,
        calendarEvents: action.payload,
        eventsAreLoading: false,
      }
    case GET_ALL_EVENTS_CALENDAR_SUCCESS:
      return {
        ...state,
        allEventsCalendar: action.payload,
        loading: false,
      }
    case GET_ALL_CALENDAR_EVENTS_SUCCESS:
      return {
        ...state,
        allCalendarEvents: action.payload,
        loading: false,
      }
    case GET_EVENT_CALENDAR_GROUP_SUCCESS:
    case CREATE_EVENT_CALENDAR_SUCCESS:
    case UPDATE_EVENT_CALENDAR_SUCCESS:
      return {
        ...state,
        selectedCalendar: action.payload,
        loading: false,
      }
    case RESET_EVENT_CALENDAR_GROUP:
      return {
        ...state,
        selectedCalendar: null,
      }
    case DELETE_EVENT_CALENDAR_SUCCESS:
    case CLONE_EVENT_CALENDAR_SUCCESS:
    case DELETE_CALENDAR_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case CHECK_EVENT_CALENDAR_CAN_BE_DELETED_SUCCESS:
      return {
        ...state,
        eventCalendarCanBeDeleted: action.payload,
        loading: false,
      }
    case OPEN_DELETE_EVENT_CALENDAR_MODAL:
      return {
        ...state,
        deleteEventCalendarModalIsOpen: true,
      }
    case HIDE_DELETE_EVENT_CALENDAR_MODAL:
      return {
        ...state,
        deleteEventCalendarModalIsOpen: false,
      }
    case OPEN_CLONE_EVENT_CALENDAR_MODAL:
      return {
        ...state,
        cloneEventCalendarModalIsOpen: true,
      }
    case HIDE_CLONE_EVENT_CALENDAR_MODAL:
      return {
        ...state,
        cloneEventCalendarModalIsOpen: false,
      }
    case OPEN_DELETE_CALENDAR_EVENT_MODAL:
      return {
        ...state,
        deleteCalendarEventModalIsOpen: true,
      }
    case HIDE_DELETE_CALENDAR_EVENT_MODAL:
      return {
        ...state,
        deleteCalendarEventModalIsOpen: false,
      }
    default:
      return state
  }
}

export default Events
